<div *ngIf="brandError" class="alert alert-danger alert-dismissible">
  <strong class="me-1" *ngIf="brandError.title">{{brandError.title}}</strong>
  <span [innerHTML]="brandError.text" [ngClass]="{'me-3': brandError.dismissible}"></span>
  <button *ngIf="brandError.dismissible" type="button" style='font-size: x-small' class="btn-close btn-close-white " (click)="brandError = undefined;" aria-label="Close">
  </button>
</div>

<div class="d-flex justify-content-end">
  <button id="topnextOrder" type="submit" (click)="next(application)" class="btn btn-primary me-3">
    Next
  </button>
  <div *ngIf="!isRenew()">
    <button i18n class="btn btn-secondary" type="button" (click)="cancelOrder()" id="topcanOrder">
      {{ isPayLater() ? "Cancel" : "Clear Order" }}
    </button>
  </div>
  <div *ngIf="isRenew()">
    <button i18n class="btn btn-secondary" type="button" (click)="cancelOrder()" id="topcanOrder">
      Cancel Renew
    </button>
  </div>
</div>
<h3> CSC Registrant </h3>
<div class="my-3">
  The CSC Registrant is the primary point of contact for the organization that is leasing the short code(s) on behalf of the Brand Client.
</div>
<div class="my-3">
  <app-address-book (addressChosen)="loadApplicantAddress($event)"></app-address-book>
</div>
<div class="row my-4">
  <div class="col-md-3">
    <strong>Account ID:</strong>
    {{ pendingOrder.accountId }}
  </div>
  <div class="col-md-9 truncate" [pTooltip]="pendingOrder.company ? pendingOrder.company: ''" tooltipPosition="top" appShowToolTipIfTruncated>
    <strong>Organization Name:</strong>
    {{ pendingOrder.company }}
  </div>
</div>
<form id="application-form" (keydown.enter)="handleEnter($event)" class="presubmit" #application="ngForm" (ngSubmit)="next(application)">
  <div class="row my-4">
    <div class="col-md-4">
      <label for="appFirstName" class="required">First Name</label>
      <input appScrText placeholder="First Name" appFirstNameValidator required maxlength="{{MaxLen.FirstName}}" autocomplete="given-name" id="appFirstName" name="appFirstName"
        #appFirstName="ngModel" [(ngModel)]="leaseApplicationData.firstName" />
      <app-error-msg [field]="appFirstName" fieldLabel="First Name"></app-error-msg>
    </div>
    <div class="col-md-4">
      <label for="appLastName" class="required">Last Name</label>
      <input appScrText placeholder="Last Name" appLastNameValidator required maxlength="{{MaxLen.LastName}}" autocomplete="family-name" id="appLastName" name="appLastName"
        #appLastName="ngModel" [(ngModel)]="leaseApplicationData.lastName" />
      <app-error-msg [field]="appLastName" fieldLabel="Last Name"></app-error-msg>
    </div>
  </div>
  <div class="row my-4">
    <div class="col-md-2">
      <label for="appPhoneInput" class="required">Phone Number</label>
      <app-phone [(ngModel)]="leaseApplicationData.phone" #appPhone="ngModel" class="col-12" required name="appPhone" id="appPhone" autocomplete="tel"></app-phone>
      <app-error-msg [field]="appPhone" fieldLabel="Phone Number"></app-error-msg>
    </div>
    <div class="col-md-2">
      <label for="appExt">Extension</label>
      <input appScrText [(ngModel)]="leaseApplicationData.phoneExtension" id="appExt" name="appExt" autocomplete="tel-extension" maxlength="{{MaxLen.PhoneExtension}}" />
    </div>
  </div>
  <div class="row my-4">
    <div class="col-md-6">
      <label for="appEmail" class="required">Email</label>
      <input appScrText placeholder="Email" required appPublicDomainEmailValidator [publicEmailDomains]="publicEmailDomains" id="appEmail" name="appEmail" #appEmail="ngModel"
        autocomplete="email" [(ngModel)]="leaseApplicationData.email" maxlength="{{MaxLen.Email}}" />
      <app-error-msg [field]="appEmail" fieldLabel="Email"></app-error-msg>
    </div>
    <div class="col-md-3">
      <label for="appCountry" class="required">Country</label>
      <app-country-dropdown id="appCountry" [(ngModel)]="leaseApplicationData.country" name="appCountry" autocomplete="country" #appCountry="ngModel"></app-country-dropdown>
      <app-error-msg [field]="appCountry" fieldLabel="Country"></app-error-msg>
    </div>
  </div>
  <div class="row my-4">
    <div class="col-10">
      <label for="appAddress1" class="required">Street Address 1</label>
      <input appScrText placeholder="Street Address 1" required maxlength="{{MaxLen.Address}}" id="appAddress1" autocomplete="address-line1" name="appAddress1"
        #appAddress1="ngModel" [(ngModel)]="leaseApplicationData.address1" />
      <app-error-msg [field]="appAddress1" fieldLabel="Street Address 1"></app-error-msg>
    </div>
  </div>
  <div class="row my-4">
    <div class="col-10">
      <label for="appAddress2">Street Address 2</label>
      <input appScrText placeholder="Street Address 2" maxlength="{{MaxLen.Address}}" id="appAddress2" autocomplete="address-line2" name="appAddress2" #appAddress2="ngModel"
        [(ngModel)]="leaseApplicationData.address2" />
    </div>
  </div>
  <div class="row my-4">
    <div class="col-md-3">
      <label for="appCity" class="required">City</label>
      <input appScrText placeholder="City" required maxlength="{{MaxLen.City}}" id="appCity" name="appCity" autocomplete="address-level2" #appCity="ngModel"
        [(ngModel)]="leaseApplicationData.city" />
      <app-error-msg [field]="appCity" fieldLabel="City"></app-error-msg>
    </div>
    <div class="col-md-3">
      <label for="appRegion" [ngClass]="{ required: getRegionRequired() }">State/Province</label>
      <app-region-dropdown [(ngModel)]="leaseApplicationData.state" [country]="leaseApplicationData.country" autocomplete="address-level1" name="appRegion" #appRegion="ngModel"
        id="appRegion"></app-region-dropdown>
      <app-error-msg [field]="appRegion" fieldLabel="State/Province"></app-error-msg>
    </div>
    <div class="col-md-3">
      <label for="appZipInput" [ngClass]="{ required: getRegionRequired() }">Zip/Postal Code</label>
      <app-zipcode-input [(ngModel)]="leaseApplicationData.zip" [country]="leaseApplicationData.country" name="appZip" #appZip="ngModel" id="appZip" inputId="appZipInput"
        placeholder="Zip/Postal Code" maxlength="{{MaxLen.Zip}}"></app-zipcode-input>
      <app-error-msg [field]="appZip" fieldLabel="Zip/Postal Code"></app-error-msg>
    </div>
  </div>

  <hr />

  <app-intended-usage [usagesEnabled]="usagesEnabled" [codeType]="codeType" [largeHeadingSize]="true" (update)="setCodeType($event)">
    <div blurb class="my-3">
      In this section, indicate the intended use for the short code(s) at this time.
    </div>
  </app-intended-usage>

  <hr />

  <h3>Associated Brand Clients</h3>
  <div class="row">
    <div class="col-10 my-2">
      The Brand Client is the entity whose message content is being sent to wireless subscribers.
      In this section, you must identify all vetted brand clients associated with the short code(s).
    </div>
    <div class="col-10 my-2">
      <label for="brandClients" [ngClass]="{ required: !leaseApplicationData.parkedCode && !leaseApplicationData.demoCode }">Brand Clients</label>

      <p-multiSelect #bc id="brandClients" appMs name="brandClients" selectedItemsLabel="{0} Brand Clients selected" [maxSelectedLabels]='maxSelectedLabels' class="p-formcontrol"
        [required]="!leaseApplicationData.parkedCode && !leaseApplicationData.demoCode" #brandClients="ngModel" optionValue="value" optionLabel="label" [options]="brandOptions"
        [(ngModel)]="leaseApplicationData.brandIds" placeholder="Select Brand Clients" scrollHeight="250px"
        [style]="{'width': '75%'}" [panelStyle]="{'width':'400px'}"
        [showToggleAll]="false" (onChange)="brandSelected(bc, $event)" [display]="multiSelectDisplay" [disabled]="codeType === 'demo' || codeType === 'parked'">
        >
        <ng-template let-group pTemplate="group">
          <div class="flex align-items-center">
            <span>{{ group.label }}</span>
          </div>
        </ng-template>
      </p-multiSelect>
      <app-error-msg [field]="brandClients" fieldLabel="Brand Clients"></app-error-msg>
    </div>
  </div>
  <hr />

  <h3>Content Provider</h3>
  <div class="row">
    <div class="col-10 my-2">
      A Content Provider is the entity who has a contractual relationship with the brand that is sending
      messages to wireless subscribers. In this section, you must identify the Content Provider associated
      with the short code(s).  Content Providers are defined from the My Partners > Content Provider List page.
      On that page, you can also access a report of Content Providers for existing short code leases.
    </div>
    <div class="col-4 my-2">
      <label for="contentProvider" [ngClass]="{ required: codeType === 'active' }">Content Provider</label>
      <p-dropdown appDd [filter]="true" placeholder="Select Content Provider" [options]="contentProviderOptions" optionLabel="label" optionValue="value"
        [required]="codeType === 'active'" name="contentProvider" id="contentProvider" #contentProvider="ngModel" [(ngModel)]="leaseApplicationData.cpId"></p-dropdown>
      <app-error-msg [field]="contentProvider" fieldLabel="Content Provider"></app-error-msg>
    </div>
  </div>

  <hr />



  <h3> Direct Connection Aggregator </h3>
  <div class="row">
    <div class="col-md-10 my-3">
      A Direct Connection Aggregator (DCA) is any entity which delivers SMS or MMS messages from an application from Message Senders to
      wireless subscribers on a Carrier's network.
      <b>This service is not included in your short code lease.
        You will be charged an additional fee, as negotiated with your selected partners.</b>
    </div>
  </div>
  <div class="row my-4">
    <div class="col-md-4">
      <label for="aggregator" class="required">Direct Connection Aggregator</label>
      <p-dropdown appDd [filter]="true" placeholder="Direct Connection Aggregator" [options]="aggregators" optionLabel="name" optionValue="aggregatorId" [required]="true"
        name="aggregator" id="aggregator" #aggregator="ngModel" [(ngModel)]="leaseApplicationData.aggregatorId"></p-dropdown>
      <app-error-msg [field]="aggregator" fieldLabel="Direct Connection Aggregator"></app-error-msg>
    </div>
  </div>
  <hr />

  <h3> Application Service Provider </h3>
  <div class="row">
    <div class="col-md-10 my-3">
      An Application Service Provider is the entity that offers individuals or enterprises access to application software
      and related services to help them create, launch, and manage messaging campaigns.
      <b>This service is not included in your short code lease.
        You will be charged an additional fee, as negotiated with your selected partners.</b>
    </div>
  </div>
  <div class="row my-4">
    <div class="col-md-6">
      <label for="appProvider" class="required">Application Service Provider</label>
      <input appScrText placeholder="Application Service Provider" required id="appProvider" name="appProvider" #appProvider="ngModel"
        [(ngModel)]="leaseApplicationData.applicationProvider" maxlength="{{MaxLen.ApplicationProvider}}" />
      <app-error-msg [field]="appProvider" fieldLabel="Application Service Provider"></app-error-msg>
    </div>
  </div>
  <hr />
  <h3> Are these codes for Political Campaigns? </h3>
  <div class="row my-4">
    <div class="col-md-2">
      <p-radioButton name="political" label="No" [value]="false" [(ngModel)]="leaseApplicationData.forPoliticalCampaign" (click)="clearFields()">
      </p-radioButton>
    </div>
    <div class="col-md-2">
      <p-radioButton name="political" label="Yes" [value]="true" (click)="selectCampaignType()" [(ngModel)]="leaseApplicationData.forPoliticalCampaign"></p-radioButton>
    </div>
  </div>
  <div class="row my-4">
    <div class="col-md-4">
      <label for="campaignType" [ngClass]="{ required: leaseApplicationData.forPoliticalCampaign }">Campaign Type</label>
      <p-dropdown appDd (onChange)="onChangeCampaignType(campaignTypeChoice)" [options]="campaignTypeOptions" [(ngModel)]="campaignTypeChoice" scrollHeight="400"
        name="campaignTypeDD" id="campaignTypeDD" #campaignTypeDD="ngModel" [disabled]="!leaseApplicationData.forPoliticalCampaign">
      </p-dropdown>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-md-4">
      <label for="fecId">FEC ID (Format: 9 Alphanumeric Characters)</label>
      <input appScrText appUppercase mask="AAAAAAAAA" appFecIdValidator [validation]="false" [(ngModel)]="leaseApplicationData.fecId" placeholder="FEC ID" #fecId="ngModel"
        id="fecId" name="fecId" [disabled]="!leaseApplicationData.forPoliticalCampaign || leaseApplicationData.politicalCampaignType !== 'Federal'" />
    </div>
  </div>
  <div class="row col-4">
    <small>
      The FEC ID is a unique identifier for the political campaign. An FEC ID is 9 alphanumeric characters,
      starting with C, H, S, or P.
    </small>
  </div>
  <div class="row mt-4">
    <div class="col-md-4">
      <label for="politicalCampaignInfo">Filing URL or Other Identifying Information</label>
      <input appScrText [maxlength]="255" [(ngModel)]="leaseApplicationData.politicalCampaignInfo" placeholder="Filing URL or other identifying information"
        #politicalCampaignInfo="ngModel" id="politicalCampaignInfo" name="politicalCampaignInfo"
        [disabled]="!leaseApplicationData.forPoliticalCampaign || leaseApplicationData.politicalCampaignType === 'Federal'" />
    </div>
  </div>
  <div class="row col-4">
    <small>
      Use this space to provide identifying information about the political campaign.
      Alternately, you can indicate that additional information will be sent to the Short Code Registry separately.
    </small>
  </div>
  <hr />

  <div class="footer">
    <div class="d-flex justify-content-end">
      <button id="nextOrder" type="submit" class="btn btn-primary me-3">
        Next
      </button>
      <div *ngIf="!isRenew()">
        <button i18n class="btn btn-secondary" type="button" (click)="cancelOrder()" id="canOrder">
          {{ isPayLater() ? "Cancel" : "Clear Order" }}
        </button>
      </div>
      <div *ngIf="isRenew()">
        <button i18n class="btn btn-secondary" type="button" (click)="cancelOrder()" id="canOrder">
          Cancel Renew
        </button>
      </div>
    </div>
  </div>

</form>


<p-confirmDialog key='canOrder' #canOrder width="425" [closable]="false" [blockScroll]="false">
  <p-footer>
    <button i18n id="canAccept" class="btn btn-primary me-2" (click)="canOrder.accept()">Yes</button>
    <button i18n id="canReject" class="btn btn-secondary" (click)="canOrder.reject()">No</button>
  </p-footer>
</p-confirmDialog>


<p-confirmDialog key='confirmParkedCodes' #confirmParkedCodes width="425" [closable]="false" [blockScroll]="false">
  <p-footer>
    <button i18n id="confirmParkedCodesAccept" class="btn btn-primary me-2" (click)="confirmParkedCodes.accept()">Yes</button>
    <button i18n id="confirmParkedCodesReject" class="btn btn-secondary" (click)="confirmParkedCodes.reject()">No</button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog key='confirmDemoCodes' #confirmDemoCodes width="425" [closable]="false" [blockScroll]="false">
  <p-footer>
    <button i18n id="confirmDemoCodesAccept" class="btn btn-primary me-2" (click)="confirmDemoCodes.accept()">Yes</button>
    <button i18n id="confirmDemoCodesReject" class="btn btn-secondary" (click)="confirmDemoCodes.reject()">No</button>
  </p-footer>
</p-confirmDialog>